export default __webpack_public_path__ + "static/media/profile.e2cd1b81.svg";